export default "__VITE_PUBLIC_ASSET__24c23271__"